import { QueryClient } from '@tanstack/react-query';
import { axiosClient } from './axiosClient';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      queryFn: async ({ queryKey }) => {
          const { data } = await axiosClient.get(queryKey[0] as string);
          return data;
      }
    },
  },
});

export const headers = {
  headers: {
    'Content-Type': 'application/json',
  },
};
